import { ApiUtility } from "../Utilities/ApiUtility.axios";

export interface IYearlyPayrollSetting {
  id: string;
  yearId: number;

  defaultTaxCode: string;

  fpsns: string;
  fpsVer: string;

  eyuns: string;
  eyuVer: string;

  epsns: string;
  epsVer: string;

  nvrns: string;
  nvrVer: string;

  // P11DNS : string; new add
  p60BottomLine: string;
  statePensionAge: number;

  eaLimit: number;
  awe: number;

  waitingDays: number; // new add

  sspWkPay: number;
  sapawePay: number;
  // sncpawePay : number; new add 
  smpawePay: number;

  ppBirthAWEPay: number;
  ppAdoptionAWEPay: number;

  // spReclaimRateSER: number; new add
  // spReclaimRate : number; new add

  // Student loan
  stdLoanPlan1Weekly: number;
  stdLoanPlan1Monthly: number;
  stdLoanPlan1Annual: number;

  stdLoanPlan2Weekly: number;
  stdLoanPlan2Monthly: number;
  stdLoanPlan2Annual: number;

  stdLoanPlan4Weekly: number;
  stdLoanPlan4Monthly: number;
  stdLoanPlan4Annual: number;

  stdLoanPlan5Weekly: number; // new add
  stdLoanPlan5Monthly: number; // new add
  stdLoanPlan5Annual: number; // new add

  // Postgraduate loan
  postgraduateLoanWeekly: number;
  postgraduateLoanMonthly: number;
  postgraduateLoanAnnual: number;

  stdLoanPer: number;
  postgraduateLoanPer: number;

  pensionLowerLimit: number;
  pensionUpperLimit: number;

  eeDirAnnualLimit: number;
  erDirAnnualLimit: number;

  loanIntRate: number;
  taTaxableFrom: number;

  // p11DQRExemptAmount: number; new add
  // p11DLAMinLimit: number; new add
  // p11DCarFuelMultiplier: number; new add
  // p11DVanFuelMultiplier: number; new add
  // p11DVanBenefit: number; new add

  //  class1ANIC : Class1ANICThresholds; new add 

  niThresholds: INIThresholds[];
  niRates: INIRates[];

  taxData: ITaxData[];
  fixedCodeTax: IFixedCodeTax;

  carCo2Emmission: ICarCo2Emmission[];
  carEleRanage: ICarEleRanage[];
  carEngineSize: ICarEngineSize[];

  deaStandard: IAEOThresholds[];
  deaHigher: IAEOThresholds[];
  deaeas: IAEOThresholds[];
  deamc: IAEOThresholds[];
  deactw: IAEOThresholds[];
  deacte: IAEOThresholds[];

  // minimumWage: MinimumWage[]; new add 
}

export const defaultPayrollYearlySettings: IYearlyPayrollSetting = {
  id: "",
  yearId: 0,
  defaultTaxCode: "",
  awe: 0,
  waitingDays: 0,
  eaLimit: 0,
  sspWkPay: 0,
  sapawePay: 0,
  smpawePay: 0,
  ppBirthAWEPay: 0,
  ppAdoptionAWEPay: 0,
  stdLoanPlan1Weekly: 0,
  stdLoanPlan1Monthly: 0,
  stdLoanPlan1Annual: 0,
  stdLoanPlan2Weekly: 0,
  stdLoanPlan2Monthly: 0,
  stdLoanPlan2Annual: 0,
  stdLoanPlan4Weekly: 0,
  stdLoanPlan4Monthly: 0,
  stdLoanPlan4Annual: 0,
  stdLoanPlan5Weekly: 0,
  stdLoanPlan5Monthly: 0,
  stdLoanPlan5Annual: 0,
  postgraduateLoanWeekly: 0,
  postgraduateLoanMonthly: 0,
  postgraduateLoanAnnual: 0,
  stdLoanPer: 0,
  postgraduateLoanPer: 0,
  pensionLowerLimit: 0,
  pensionUpperLimit: 0,
  loanIntRate: 0,
  eeDirAnnualLimit: 0,
  erDirAnnualLimit: 0,
  taTaxableFrom: 0,
  p60BottomLine: "",
  fpsns: "",
  fpsVer: "",
  epsns: "",
  epsVer: "",
  nvrns: "",
  nvrVer: "",
  eyuns: "",
  eyuVer: "",
  niThresholds: [],
  niRates: [],
  taxData: [],
  fixedCodeTax: {
    br: 0,
    d0: 0,
    d1: 0,
    sbr: 0,
    sD0: 0,
    sD1: 0,
    sD2: 0,
    cbr: 0,
    cD0: 0,
    cD1: 0,
  },
  carCo2Emmission: [],
  carEleRanage: [],
  carEngineSize: [],
  statePensionAge: 0,
  deaStandard: [],
  deaHigher: [],
  deaeas: [],
  deamc: [],
  deactw: [],
  deacte: []
};


// DEARate
export interface IAEOThresholds {
  payFrequency: EmployeePayFrequency;
  lowerLimit: number;
  higherLimit: number;
  Rate: number;
  id: number;
}
export interface MinimumWage {
  MinAge: number;
  MaxAge: number;
  Rate: number;
}
export interface INIThresholds {
  id: number;
  payFrequency: EmployeePayFrequency;
  director: boolean;
  payDateFrom: Date;
  payDateTo: Date;

  lel: number;
  pt: number;
  st: number;

  aust: number;
  ust: number;
  fust: number;

  izust: number;
  vust: number;

  uel: number;
  auel: number;
}

export interface Class1ANICThresholds {
  PayDateFrom?: Date;
  PayDateTo?: Date;
  Rate: number;
}

export interface INIRates {
  id: number;
  niCategory: EmployeesNICategory;
  isAM: boolean;
  payDateFrom: Date;
  payDateTo: Date;

  // Employee's contribution limits
  eeRateLEL: number;
  eeRatePT: number;
  eeRateUST: number;
  eeRateFUST: number;
  eeRateAUST: number;
  eeRateVUST: number;
  eeRateUEL: number;
  eeRateAUEL: number;
  // eeRateIZUST: number; new 

  // Employer's contribution limits
  erRateST: number;
  erRateUST: number;
  erRateFUST: number;
  erRateAUST: number;
  erRateVUST: number;
  erRateUEL: number;
  erRateAUEL: number;
  // erRateIZUST: number; new 

}

export interface ITaxData {
  id: number;
  taxCodeType: TaxCodeType;
  payFrequency: EmployeePayFrequency;
  period: number;
  minAmount: number;
  maxAmount: number;
  taxPer: number;
}

export interface ICarAllowanceBase {
  id: number,
  isOld: boolean;
  fuelType: FuelType;
  calcPer: number;
}

export interface ICarCo2Emmission extends ICarAllowanceBase {
  co2EmmisionFrom: number;
  co2EmmisionTo: number;
}

export interface ICarEleRanage extends ICarAllowanceBase {
  eleRangeFrom: number;
  eleRangeTo: number;
}

export interface ICarEngineSize extends ICarAllowanceBase {
  engineSizeFrom: number;
  engineSizeTo: number;
}

interface IFixedCodeTax {
  br: number;
  d0: number;
  d1: number;
  sbr: number;
  sD0: number;
  sD1: number;
  sD2: number;
  cbr: number;
  cD0: number;
  cD1: number;
}

export enum TaxCodeType {
  EnglishNorthernIrish = 1,
  Scottish = 2,
  Welsh = 3,
}
export const TaxCodeTypeOptionList = [
  { label: "Northrn Ireland", value: TaxCodeType.EnglishNorthernIrish },
  { label: "Scotland", value: TaxCodeType.Scottish },
  { label: "England and Wales", value: TaxCodeType.Welsh },
]

export enum FuelType {
  DieselEuro6d = 1,
  Diesel,
  Other,
  Hybrid,
  Electric,
}
export const FuelTypesOptionList = [
  { label: "Diesel Euro 6d", value: FuelType.DieselEuro6d },
  { label: "Diesel", value: FuelType.Diesel },
  { label: "Other", value: FuelType.Other },
  { label: "Hybrid", value: FuelType.Hybrid },
  { label: "Electric", value: FuelType.Electric },
]

export enum EmployeePayFrequency {
  null,
  Monthly = 1,
  Weekly,
  Two_Weekly,
  Four_Weekly,
  Annual,
  Fortnightly,
  Quarterly,
  Bi_annual
}
export const EmployeePayFrequencyOptionList = [
  { label: "Monthly", value: EmployeePayFrequency.Monthly },
  { label: "Weekly", value: EmployeePayFrequency.Weekly },
  { label: "Two Weekly", value: EmployeePayFrequency.Two_Weekly },
  { label: "Four Weekly", value: EmployeePayFrequency.Four_Weekly },
  { label: "Annual", value: EmployeePayFrequency.Annual },
  { label: "Fortnightly", value: EmployeePayFrequency.Fortnightly },
  { label: "Quarterly", value: EmployeePayFrequency.Quarterly },
  { label: "Bi-annual", value: EmployeePayFrequency.Bi_annual },
];

// NICategory
export enum EmployeesNICategory {
  undefined = 0,
  A = 1,   //  All employees apart from those in groups B, C, J, H, M, X and Z in this table.
  B = 2,   //  Married women and widows entitled to pay reduced National Insurance.
  C = 3,   //  Employees over the State Pension age.
  H = 4,   //  Apprentice under 25.
  J = 5,   //  Employees who can defer National Insurance because they’re already paying it in another job.
  M = 6,   //  Employees under 21.
  X = 7,   //  Employees who do not have to pay National Insurance. (Ex. Employee age under 16.)
  Z = 8,   //  Employees under 21 who can defer National Insurance because they’re already paying  //     it in another job.
  F = 9,   //  Freeport.
  I = 10,  //  Freeport – married women and widows reduced rate
  L = 11,  //  Freeport – deferment
  S = 12,  //  Freeport – state pensioner
  V = 13,  //  Veterans
  D = 14,  //  Investment Zone.
  E = 15,  //  Investment
  K = 16,  //  Investment Zone – deferment
  N = 17,  //  Investment Zone – state pensioner
}
export const EmployeesNICategoryList = [
  { label: "A", value: EmployeesNICategory.A, tooltip: 'All employees apart from those in groups B, C, J, H, M, X and Z in this table.' },
  { label: "B", value: EmployeesNICategory.B, tooltip: 'Married women and widows entitled to pay reduced National Insurance.' },
  { label: "C", value: EmployeesNICategory.C, tooltip: 'Employees over the State Pension age.' },
  { label: "H", value: EmployeesNICategory.H, tooltip: 'Apprentice under 25.' },
  { label: "J", value: EmployeesNICategory.J, tooltip: 'Employees who can defer National Insurance because they’re already paying it in another job.' },
  { label: "M", value: EmployeesNICategory.M, tooltip: 'Employees under 21.' },
  { label: "X", value: EmployeesNICategory.X, tooltip: 'Employees who do not have to pay National Insurance. (Ex. Employee age under 16.)' },
  { label: "Z", value: EmployeesNICategory.Z, tooltip: 'Employees under 21 who can defer National Insurance because they’re already paying it in another job.' },
  { label: "F", value: EmployeesNICategory.F, tooltip: 'Freeport. (Below categroires are use on after 06/04/2022.)' },
  { label: "I", value: EmployeesNICategory.I, tooltip: ' Freeport – married women and widows reduced rate.' },
  { label: "L", value: EmployeesNICategory.L, tooltip: ' Freeport – deferment.' },
  { label: "S", value: EmployeesNICategory.S, tooltip: ' Freeport – state pensioner.' },
  { label: "V", value: EmployeesNICategory.V, tooltip: ' Veterans.' },
  { label: "D", value: EmployeesNICategory.D, tooltip: ' Investment Zone. (Below categroires are use on after 06/04/2024.)' },
  { label: "E", value: EmployeesNICategory.E, tooltip: ' Investment.' },
  { label: "K", value: EmployeesNICategory.K, tooltip: ' Investment Zone – deferment.' },
  { label: "N", value: EmployeesNICategory.N, tooltip: ' Investment Zone – state pensioner.' },
];

export const enum PayrollYearlySettingsTabs {
  general = 1,
  allowanceLimitsNdloansThersholds = 2,
  niThresholds = 3,
  niRates = 4,
  taxData = 5,
  carAllowances = 6,
  aeoRates = 7,
}

export const PayrollYearlySettingsTabsNameList = ["none", "Generals", "Allowances Limits & Loans Thersholds", "NI Thersholds", "NI Rates", "Tax Data", "Car Allowances", "AEO Rates"];
export const enum PayrollYearlySettingsUpdateTypes {
  none = 0,
  generalInformation = 1,
  fixedCodeTax = 2,
  allowanceLimits = 3,
  loansThersholds = 4,
  niThresholds = 5,
  niRates = 6,
  taxData = 7,
  carAllowances = 8,
}

export enum CarAllowanceListType {
  CarCo2Emmission = 1,
  CarEngineSize = 2,
  CarEleRange = 3,
}
export const CarAllowanceOptionList = [
  { value: CarAllowanceListType.CarCo2Emmission, label: "Car Co2 Emmision List" },
  { value: CarAllowanceListType.CarEngineSize, label: "Car Electric Size List" },
  { value: CarAllowanceListType.CarEleRange, label: "Car Engine Range List" },
]

export const enum AEORatesType {
  DEAStandard = 1,
  DEAHigher = 2,
  DEAEAS = 3,
  DEAMC = 4,
  DEACTW = 5,
  DEACTE = 6,
}
export const AEORatesTypesOptionList = [
  { label: "AEO Standard rate", value: AEORatesType.DEAStandard },
  { label: "AEO Higher rate", value: AEORatesType.DEAHigher },
  { label: "AEO Earnings arrangement scotland rate", value: AEORatesType.DEAEAS },
  { label: "AEO Magistrates court rate", value: AEORatesType.DEAMC },
  { label: "AEO Council tax wales rate", value: AEORatesType.DEACTW },
  { label: "AEO Council tax england rate", value: AEORatesType.DEACTE }
];

class PayrollYearlySettingsService {
  route = `/Api/PayrollYearlySettings`;

  getPayrollYearlySettingsList = (
    start: number,
    length: any,
    search: string,
    sortCol: any,
    sortDir: any,
    yearId: number[] | undefined
  ) =>
    ApiUtility.get(`${this.route}`, {
      start,
      length,
      search,
      sortDir,
      sortCol,
      yearId
    });

  getPayrollYearlySettings = (
    id: number,
    type: number,
    carAllowanceListType: CarAllowanceListType,
    aeoRates: AEORatesType
  ) =>
    ApiUtility.get(`${this.route}/${id}`, {
      type,
      carAllowanceListType,
      aeoRates
    });

  postPayrollYearlySettingsDetails = (id: string, type: number, params: any) => ApiUtility.post(`${this.route}/${id}/${type}`, params);

  AddPayrollYearlySettings = (params: any, id?: number) => ApiUtility.post(`${this.route}/addpayeyearlysettings?id=${id}`, params);

  updateNIThersholdItem = (id: string, params: any, itemId?: any,) => ApiUtility.post(`${this.route}/savenithersholds/${id}/${itemId}`, params);

  updateNIRatesItem = (id: string, params: any, itemId?: any,) => ApiUtility.post(`${this.route}/savenirates/${id}/${itemId}`, params);

  updateAEORatesItem = (id: string, listType: AEORatesType, params: any, itemId?: any,) => ApiUtility.post(`${this.route}/saveaeorate/${id}/${listType}/${itemId}`, params);

  updateCarAllowanceItem = (id: string, listType: CarAllowanceListType, params: any, itemId?: any,) => ApiUtility.post(`${this.route}/savecarallowance/${id}/${listType}/${itemId}`, params);
};

export default new PayrollYearlySettingsService();




